import { Socket } from 'socket.io-client';
import toast from 'react-hot-toast';

export interface QuickActionsPanelProps {
  sessionId: string;
  socket: Socket | null;
  isConnected: boolean;
  onResetVotes?: () => Promise<void>;
  onResetDisplay?: () => void;
}

export function QuickActionsPanel({
  sessionId,
  socket,
  isConnected,
  onResetVotes,
  onResetDisplay,
}: QuickActionsPanelProps) {
  const handleResetVotes = async () => {
    if (!confirm('🔄 RESET VOTAZIONI: Cancellare tutte le votazioni e tornare a standby?\n\nGli spettatori rimarranno connessi.')) return;

    if (onResetVotes) {
      await onResetVotes();
    } else {
      try {
        const response = await fetch(`/api/sessions/${sessionId}/reset-votes`, {
          method: 'POST',
        });

        if (response.ok) {
          const data = await response.json();

          if (socket && isConnected) {
            socket.emit('admin:set-projection', {
              sessionId,
              mode: { type: 'standby' },
            });
          }

          toast.success(`Reset completato: ${data.votesDeleted} votazioni rimosse`);
        } else {
          toast.error('Errore durante il reset delle votazioni');
        }
      } catch (error) {
        console.error('[QuickActions] Reset votes error:', error);
        toast.error('Errore reset votazioni');
      }
    }
  };

  const handleResetDisplay = () => {
    if (!socket || !isConnected) {
      toast.error('Socket non connesso. Impossibile resettare il display.');
      return;
    }

    if (onResetDisplay) {
      onResetDisplay();
    } else {
      socket.emit('admin:reset-display', { sessionId });
      toast.success('Segnale reset display inviato.');
    }
  };

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
      <h3 className="text-xl font-bold text-white mb-4">Azioni Rapide</h3>
      <p className="text-gray-400 text-sm mb-4">
        Controlli per gestire lo show in tempo reale
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <button
          onClick={handleResetVotes}
          className="bg-red-700 hover:bg-red-800 text-white py-3 px-4 rounded-lg font-semibold transition-all shadow-lg flex items-center justify-center gap-2"
        >
          <span className="text-2xl">🔄</span>
          <span>Reset Votazioni</span>
        </button>

        <button
          onClick={handleResetDisplay}
          disabled={!isConnected}
          className="bg-orange-700 hover:bg-orange-800 disabled:bg-gray-700 disabled:cursor-not-allowed text-white py-3 px-4 rounded-lg font-semibold transition-all shadow-lg flex items-center justify-center gap-2"
        >
          <span className="text-2xl">📺</span>
          <span>Reset Display</span>
        </button>
      </div>

      {!isConnected && (
        <div className="mt-4 p-3 bg-yellow-900/30 border border-yellow-600 rounded-lg">
          <p className="text-yellow-300 text-sm">
            ⚠️ Alcune azioni richiedono la connessione socket
          </p>
        </div>
      )}
    </div>
  );
}
